import './styles.scss'
import { I18n } from 'react-redux-i18n'
import React from 'react'
import FacebookLogin from 'react-facebook-login'

import FB_CONFIG from 'constants/facebook.constants'

/**
 * Facebook login component
 * @param {object} props
 * @param {['channel', 'auth', 'instagram','facebook_post' ]} props.type type of config to use
 * @param {function} props.onCallback function to return facebook response
 * @param {boolean} [props.disabled=false]
 * @param {boolean} [props.cssCustom=false] Added class "custom"
 * @param {string} [props.textTag] override textTag by default
 * @param {string} [props.scope] override scope value by default
 * @param {string} [props.fields] override fields value by default
 * @param {string} [props.icon] override icon value by default
 * @param {boolean} [props.isReRequest=false] Add rerequest login's type
 */
const FBLogin = (props) => {
  const { type, onCallback, disabled = false, cssCustom, textTag, scope, fields, icon } = props
  if (!type) return null

  const CONFIG = FB_CONFIG[type]

  try {
    if (window.FB !== undefined) {
      window.FB.init({
        version: `v${FB_CONFIG.version}`,
        appId: CONFIG.appId,
        xfbml: false,
        cookie: false,
      })
    }
  } catch (error) {
    console.error('fb login: ', error)
  }

  return (
    <FacebookLogin
      returnScopes
      appId={CONFIG.appId}
      cssClass={`kep-login-facebook facebook-login-button ${cssCustom ? 'custom' : ''}`}
      fields={fields || CONFIG.fields}
      icon={icon || CONFIG.icon}
      isDisabled={disabled}
      scope={scope || CONFIG.scope}
      textButton={I18n.t(textTag || CONFIG.textTag)}
      version={FB_CONFIG.version}
      callback={onCallback}
    />
  )
}

export default FBLogin
